import { Controller } from "@hotwired/stimulus"

// "Zugänge anlegen" (Employees::BulkAccountCreationsController): typing into the own-pattern
// field picks the "Eigenes Muster" radio, and the preview's header checkbox ticks every row
// that can be created. Everything else is decided on the server.
export default class extends Controller {
  static targets = ["customChoice", "rowCheckbox"]

  selectCustom() {
    if (this.hasCustomChoiceTarget) this.customChoiceTarget.checked = true
  }

  toggleAll(event) {
    this.rowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = event.target.checked
    })
  }
}
